import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn.js';

export type PageContainerProps = HTMLAttributes<HTMLDivElement>;

/**
 * Container canônico de página interna. **Largura única** (`max-w-6xl`) +
 * padding + ritmo vertical consistentes. Toda página autenticada deve
 * envolver seu conteúdo neste componente — isso garante que o título
 * fique exatamente no mesmo eixo entre rotas e que o grid interno comece
 * sempre a mesma distância da sidebar.
 *
 * Se uma futura tela precisar de uma largura diferente (ex: relatório
 * wide-screen, tabela densa), crie um novo pattern dedicado (ex:
 * `PageContainerWide`) em vez de parametrizar este — manter um ponto
 * único evita "cada tela com a sua largura" (regra §"Padrão para
 * páginas internas" de `docs/design-system.md`).
 */
export function PageContainer({ className, ...props }: PageContainerProps): ReactElement {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-6xl space-y-6 p-4 pb-8 sm:p-6 lg:space-y-8 lg:p-8',
        className,
      )}
      {...props}
    />
  );
}
